/* This file is auto-generated by pitspy, it was last generated: 2024-08-24T23:58:36.398497 */


export enum SurveyUserRole {
	OWNER = 0,
	EDITOR,
	PARTICIPANT
}

export enum QuestionOptionKey {
	STEP = 0
}

export enum RoleChoice {
	ADMIN = 'admin',
	MEMBER = 'member',
	PARTICIPANT = 'participant'
}

export enum SurveyShareMode {
	RESTRICTED = 0,
	EMAIL,
	LINK
}

export enum ResponseGroupCompletion {
	BLANK = 0,
	PARTIAL,
	COMPLETE
}

export enum SurveyRespondentIdentifyBy {
	IP_ADDRESS = 0
}

export enum BoardShareMode {
	RESTRICTED = 0,
	LINK
}

export enum BoardUserRole {
	OWNER = 0,
	EDITOR,
	PARTICIPANT
}

export enum BoardState {
	DRAFT = 0,
	OPEN,
	CLOSED,
	ARCHIVED
}

export enum SurveyResponseSubmittedAction {
	GO_TO_NEXT = 0,
	DONE,
	STAY_ERRORS
}

export enum SurveyState {
	DRAFT = 0,
	OPEN,
	CLOSED,
	ARCHIVED
}

export enum SurveyResponseErrorCode {
	MISSING_REQUIRED = 0
}

export enum ReportQuestionMode {
	ALL = 0,
	MANUAL,
	CURRENT
}

export enum QuestionDisplayStyle {
	DEFAULT = 0,
	STAR,
	DROPDOWN
}

export enum SurveyMemberInviteStatus {
	NA = 0,
	INVITED,
	REGISTERED
}

export enum PollResultVisibility {
	VISIBLE = 0,
	ANONYMOUS,
	PRIVATE
}

export enum QuestionChoiceBadge {
	NONE = 0,
	LETTERS,
	NUMBERS,
	EMOJIS
}

export enum MemberInviteStatus {
	NA = 0,
	INVITED,
	REGISTERED
}

export enum QuestionType {
	SHORT_TEXT_RESPONSE = 0,
	TEXT_RESPONSE,
	SINGLE_CHOICE,
	MULTIPLE_CHOICE,
	NPS,
	RATING,
	STAR_RATING
}

export enum InvalidTokenReason {
	NO_ERROR = 0,
	EXPIRED,
	MISSING,
	USED,
	FOR_DIFFERENT_ACCOUNT
}

export enum QuestionOptionType {
	BOOL = 0,
	CHAR,
	NUMBER,
	DATE,
	TIME,
	DATETIME,
	TEXT
}

export declare type PageInfo = {
	page: number;
	totalPages: number;
	numberPerPage: number;
	totalCount: number;
};

export declare type InviteTokenResponse = {
	valid: boolean;
	reason: InvalidTokenReason;
	email: string | null;
	userExists: boolean;
};

export declare type UserType = {
	email: string;
	firstName: string;
	lastName: string;
	uuid: string;
	color: string;
	role: RoleChoice;
	isRegistered: boolean;
	isActive: boolean;
	hasPassword: boolean;
	avatar: string | null;
	isElevated: boolean;
};

export declare type NotificationSettingsType = {
	productUpdates: boolean;
};

export declare type BoardPublicType = {
	name: string;
	uuid: string;
	emoji: string | null;
};

export declare type BoardType = {
	name: string;
	creator: UserType;
	uuid: string;
	emoji: string | null;
	url: string;
	state: BoardState;
	shareMode: BoardShareMode;
	createdAt: string;
	updatedAt: string;
};

export declare type BoardInfoType = BoardType & {
	configuration: BoardConfigurationType;
	canEdit: boolean;
};

export declare type BoardViewType = BoardInfoType & {
	members: Array<UserType>;
	participants: Array<UserType>;
};

export declare type BoardAdminType = BoardInfoType & {
	cardCount: number;
	voteCount: number;
	participantsCount: number;
};

export declare type BoardForUserAdminType = BoardInfoType & {
	cardCount: number;
	voteCount: number;
	commentCount: number;
	role: BoardUserRole;
};

export declare type BoardConfigurationType = {
	cardLimit: number;
	voteLimit: number;
	hideCards: boolean;
	hideVotes: boolean;
	hideCardAuthors: boolean;
	comments: boolean;
	anonymousCards: boolean;
	closeDate: string | null;
	showActiveUsers: boolean;
	introText: string | null;
	introTitle: string | null;
	introRenderedText: string | null;
	welcomeScreenEnabled: boolean;
};

export declare type BoardColumnType = {
	name: string;
	creator: UserType | null;
	index: number;
	uuid: string;
	emoji: string | null;
	participantsCanAddCards: boolean;
};

export declare type CardType = {
	text: string;
	renderedText: string;
	index: number;
	pinned: boolean;
	uuid: string;
	creator: UserType;
	column: BoardColumnType;
	createdAt: string;
	updatedAt: string;
	votes: Array<[string, string]>;
	comments: Array<CardCommentType>;
	reactions: Array<CardReactionType>;
	linkPreviews: Array<CardLinkPreviewType>;
};

export declare type CardReactionType = {
	emoji: string;
	users: Array<UserType>;
	count: number;
	reactedOn: string;
};

export declare type CardLinkPreviewType = {
	id: number;
	url: string;
	siteName: string | null;
	title: string | null;
	description: string | null;
	image: string | null;
	contentType: string;
	videoType: string | null;
	videoUrl: string | null;
};

export declare type CardCommentType = {
	text: string;
	renderedText: string;
	uuid: string;
	author: UserType;
	createdAt: string;
	updatedAt: string;
	cardUuid: string;
};

export declare type BoardMemberType = {
	user: UserType;
	cards: number;
	votes: number;
	inviteStatus: MemberInviteStatus;
	role: BoardUserRole;
};

export declare type SurveyType = {
	name: string;
	emoji: string | null;
	creator: UserType;
	uuid: string;
	editUrl: string;
	createdAt: string;
	updatedAt: string;
	state: SurveyState;
	renderedDoc: string;
	shareMode: SurveyShareMode;
	url: string;
	submitLabel: string;
	isTemplate: boolean;
};

export declare type SurveyEditType = SurveyType & {
	surveyDoc: {[key: string]: any};
	defaultReportUuid: string;
	qrCode: string | null;
	hasUnpublishedChanges: boolean;
};

export declare type SurveyForUserAdminType = SurveyEditType & {
	role: SurveyUserRole;
};

export declare type SurveyForUserAdminWithStatsType = SurveyForUserAdminType & {
	partialResponses: number;
	completedResponses: number;
};

export declare type SurveyConfigurationType = {
	identifyBy: SurveyRespondentIdentifyBy;
	allowMultipleResponses: boolean;
	closeDate: string | null;
};

export declare type SurveyMemberType = {
	user: UserType;
	responses: number;
	inviteStatus: SurveyMemberInviteStatus;
	role: SurveyUserRole;
};

export declare type SurveyNotificationsType = {
	everyResponse: boolean;
	dailySummary: boolean;
	weeklySummary: boolean;
};

export declare type SurveyQuestionType = {
	uuid: string;
	identifier: string;
	required: boolean;
	questionType: QuestionType;
	limitMax: number | null;
	limitMin: number | null;
	randomizeChoices: boolean;
	choiceBadge: QuestionChoiceBadge;
	displayStyle: QuestionDisplayStyle;
	options: Record<QuestionOptionKey, SurveyQuestionOptionType>;
	choices: Array<QuestionChoiceType>;
};

export declare type SurveyQuestionOptionType = {
	key: QuestionOptionKey;
	optionType: QuestionOptionType;
	intValue: number | null;
	textValue: string | null;
	charValue: string | null;
	datetimeValue: string | null;
};

export declare type QuestionChoiceType = {
	uuid: string;
	label: string;
	text: string | null;
	value: number | null;
	index: number;
	hasTextOption: boolean;
};

export declare type PublishedSurveyType = {
	uuid: string;
	version: number;
	name: string;
	submitLabel: string;
};

export declare type PublishedSurveyPageType = {
	uuid: string;
	name: string;
	renderedPage: string;
	questions: Array<PublishedSurveyQuestionType>;
	nextPageLabel: string;
	previousPageLabel: string;
	index: number;
};

export declare type PublishedQuestionChoiceType = {
	uuid: string;
	label: string;
	text: string | null;
	value: number | null;
	index: number;
	hasTextOption: boolean;
};

export declare type PublishedSurveyQuestionType = {
	uuid: string;
	identifier: string;
	required: boolean;
	renderedQuestion: string;
	questionType: QuestionType;
	title: string;
	plainTitle: string;
	limitMax: number | null;
	limitMin: number | null;
	randomizeChoices: boolean;
	choiceBadge: QuestionChoiceBadge;
	displayStyle: QuestionDisplayStyle;
	options: Record<QuestionOptionKey, PublishedSurveyQuestionOptionType>;
	choices: Array<PublishedQuestionChoiceType>;
};

export declare type PublishedSurveyQuestionOptionType = {
	key: QuestionOptionKey;
	optionType: QuestionOptionType;
	intValue: number | null;
	textValue: string | null;
	charValue: string | null;
	datetimeValue: string | null;
};

export declare type SurveyResponseInputErrorType = {
	questionUuid: string;
	error: string;
	field: string;
	code: SurveyResponseErrorCode;
};

export declare type SubmittedPageResults = {
	submitted: boolean;
	action: SurveyResponseSubmittedAction;
	inputErrors: Array<SurveyResponseInputErrorType> | null;
	nextPage: PublishedSurveyPageType | null;
	isLastPage: boolean;
};

export declare type ChoiceResponseType = {
	choiceUuid: string;
	text: string | null;
};

export declare type ResponseType = {
	questionUuid: string;
	text: string | null;
	value: number | null;
	choices: Array<ChoiceResponseType> | null;
	numberRange: number | null;
};

export declare type ResponseGroupType = {
	surveyUuid: string;
	publishedSurveyUuid: string;
	uuid: string;
	pagePath: Array<string>;
	completion: ResponseGroupCompletion;
	responses: Array<ResponseType>;
	createdAt: string;
	updatedAt: string;
};

export declare type QuestionChoiceModified = {
	modification: 'add' | 'remove' | 'edit' | 'reorder';
	choiceUuid: string;
	fromIndex: number | null;
	toIndex: number | null;
	choice: QuestionChoiceType | null;
};

export declare type WorkspaceType = {
	name: string;
	avatar: string | null;
	uuid: string;
	url: string;
};

export declare type WorkspaceSearchResultsType = {
	users: Array<UserType>;
	boards: Array<BoardType>;
	surveys: Array<SurveyType>;
};

export declare type WorkspaceNotificationSettingsType = {
	boardActivity: boolean;
	cardActivity: boolean;
};

export declare type PollType = {
	uuid: string;
	creator: UserType;
	question: string;
	resultVisibility: PollResultVisibility;
	choices: Array<PollChoiceType>;
	hasResponses: boolean;
};

export declare type PollChoiceType = {
	text: string;
	index: number;
	uuid: string;
};

export declare type PollResponseType = {
	respondant: UserType | null;
	choiceUuid: string;
	uuid: string | null;
};

export declare type SurveyReportType = {
	uuid: string;
	name: string;
	creator: UserType;
	surveyUuid: string;
	questionMode: ReportQuestionMode;
};

export declare type SurveyAggregateStats = {
	views: number;
	partialResponses: number;
	completeResponses: number;
	avgCompletionTime: number;
};

export declare type SurveyReportQuestionInfo = {
	questionUuid: string;
	removed: boolean;
	index: number;
	question: SurveyQuestionType;
	published: PublishedSurveyQuestionType | null;
};

export declare type SurveyTabulatedResponseGroup = {
	uuid: string;
	email: string | null;
	knownRespondant: UserType | null;
	publishedSurveyUuid: string | null;
	completion: ResponseGroupCompletion;
	createdAt: string;
	updatedAt: string;
	completedAt: string | null;
	ipAddress: string | null;
	responses: Array<ResponseType>;
};

export declare type UploadedFileType = {
	url: string;
	uploaded: UserType | null;
	uuid: string;
};
